module.exports = __webpack_public_path__ + "sq11-e5e989b2.png";